import {RequestStatus} from "../../utils/Enums";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {apiClient} from "../../utils/ApiClient";
import User from "../../models/User";

interface InfoState {
    inquiriesToday: any[];
    managedLoadings: any[];
    managedRailroadAndSea: any[];
    managedRoad: any[];
    nextUser: User | null;
    customsTlNextUser: string | null;
    meCustomsTlStatus: 'online' | 'offline' | 'none';
    me: User | null;
    unpaid: any[];
    insurance: any[];
    settings: any;
    getTodayStatus: RequestStatus;
    toggleCustomsTlOnlineStatus: RequestStatus;
}

const initialState: InfoState = {
    inquiriesToday: [],
    managedLoadings: [],
    managedRailroadAndSea: [],
    managedRoad: [],
    nextUser: null,
    customsTlNextUser: null,
    meCustomsTlStatus: 'none',
    me: null,
    unpaid: [],
    insurance: [],
    settings: {},
    getTodayStatus: RequestStatus.Idle,
    toggleCustomsTlOnlineStatus: RequestStatus.Idle
}

export const getToday = createAsyncThunk(
    'info/getToday',
    async (_, {rejectWithValue}) => {
        const response = await apiClient.get('info/today');
        return response.data;
    }
);

export const toggleCustomsTlOnline = createAsyncThunk(
    'info/toggleCustomsTlOnline',
    async (userId: number, {dispatch, rejectWithValue}) => {
        const response = await apiClient.post(`users/${userId}/toggle-customs-tl-online`);

        await dispatch(getToday());

        return response.data;
    }
);

const infoSlice = createSlice({
    name: 'info',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getToday.pending, (state) => {
                state.getTodayStatus = RequestStatus.Loading;
            })
            .addCase(getToday.fulfilled, (state, action) => {
                state.getTodayStatus = RequestStatus.Success;
                state.inquiriesToday = action.payload.inquiriesToday;
                state.managedLoadings = action.payload.managedLoadings;
                state.managedRailroadAndSea = action.payload.managedRailroadAndSea;
                state.managedRoad = action.payload.managedRoad;
                state.nextUser = action.payload.nextUser;
                state.customsTlNextUser = action.payload.customsTlNextUser;
                state.meCustomsTlStatus = action.payload.meCustomsTlStatus;
                state.unpaid = action.payload.unpaid;
                state.insurance = action.payload.insurance;
                state.me = action.payload.me;
                state.settings = action.payload.settings;
            })
            .addCase(getToday.rejected, (state, action) => {
                state.getTodayStatus = RequestStatus.Failed;
            })
            .addCase(toggleCustomsTlOnline.pending, (state) => {
                state.toggleCustomsTlOnlineStatus = RequestStatus.Loading;
            })
            .addCase(toggleCustomsTlOnline.fulfilled, (state, action) => {
                state.toggleCustomsTlOnlineStatus = RequestStatus.Success;

                if (state.me) {
                    (state.me as any).customs_tl_online = action.payload.customs_tl_online;
                }

                state.meCustomsTlStatus = action.payload.customs_tl_online ? 'online' : 'offline';
            })
            .addCase(toggleCustomsTlOnline.rejected, (state) => {
                state.toggleCustomsTlOnlineStatus = RequestStatus.Failed;
            });
    },
});

export default infoSlice.reducer;